<template>
  <FaqComponent />
</template>

<script>
import FaqComponent from "@/sections/voiceplus/components/FaqComponent.vue";
import config from "@/config";

export default {
  name: "Faq",
  components: {
    FaqComponent,
  },
  data: function () {
    return {
      sections: config.Sites,
    };
  },
};
</script>
